/* DentPDR global behaviour: window.DP and the chrome elements (design.md section 7). No dependencies. */
(() => {
  'use strict';
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.DPConfig || {};
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const PATHS = {
    check: '<path d="M20 6 9 17l-5-5"/>',
    alert: '<circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/>',
    x: '<path d="M18 6 6 18"/><path d="m6 6 12 12"/>'
  };
  const svg = (name, size) => `<svg class="dp-icon" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${PATHS[name]}</svg>`;
  const esc = (s) => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  const emit = (name, detail) => document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
  const vis = (el) => el.getClientRects().length > 0;
  const define = (name, cls) => customElements.get(name) || customElements.define(name, cls);
  const store = {
    get(k) { try { const v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; } catch (e) { return []; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  };

  /* money: copy symbol and separators from moneySample (123456 cents through the money filter, visitor's currency); shop.money_format is the fallback (D30) */
  const MONEY = { amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'], amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','], amount_with_apostrophe_separator: [2, "'", '.'] };
  function formatMoney(cents) {
    const n = Number(cents) / 100;
    const sm = cfg.moneySample && cfg.moneySample.match(/\d(?:[\d.,'\s]*\d)?/);
    if (sm) {
      const num = sm[0], dec = /[.,]\d\d$/.test(num) ? num.slice(-3, -2) : '';
      const grp = (num.slice(0, dec ? -3 : num.length).match(/\D/) || [''])[0];
      const p = n.toFixed(dec ? 2 : 0).split('.');
      return cfg.moneySample.replace(num, p[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp) + (dec ? dec + p[1] : ''));
    }
    const f = cfg.moneyFormat || '{{amount}}';
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return f;
    const [d, t, c] = MONEY[m[1]] || MONEY.amount;
    const p = n.toFixed(d).split('.');
    return f.replace(m[0], p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (p[1] ? c + p[1] : ''));
  }

  /* scroll lock, focus trap */
  let locks = 0;
  const lockScroll = () => {
    if (locks++) return;
    const h = document.documentElement;
    h.style.setProperty('--dp-scrollbar', innerWidth - h.clientWidth + 'px');
    h.classList.add('dp-scroll-lock');
  };
  const unlockScroll = () => { if (locks && !--locks) document.documentElement.classList.remove('dp-scroll-lock'); };
  function trapFocus(container, returnTo) {
    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const items = qa(FOCUSABLE, container).filter(vis), first = items[0], last = items[items.length - 1];
      if (!first) { e.preventDefault(); return; }
      const a = document.activeElement;
      if (!container.contains(a) || (e.shiftKey && a === first)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', onKey, true);
    return () => { document.removeEventListener('keydown', onKey, true); if (returnTo) returnTo.focus(); };
  }

  /* toast */
  function toast(o) {
    const region = q('toast-region');
    if (!region) return;
    const error = o.type === 'error', el = document.createElement('div');
    el.className = 'dp-toast' + (error ? ' dp-toast--error' : '');
    el.setAttribute('role', error ? 'alert' : 'status');
    el.innerHTML = `<span class="dp-toast__icon">${svg(error ? 'alert' : 'check', error ? 20 : 16)}</span><div class="dp-toast__text"><p class="dp-toast__title">${esc(o.title || '')}</p>${o.body ? `<p class="dp-toast__body">${esc(o.body)}</p>` : ''}${o.href ? `<a class="dp-toast__link" href="${esc(o.href)}">${esc(o.hrefLabel || '')}</a>` : ''}</div><button class="dp-icon-btn dp-toast__close" type="button" aria-label="${esc(region.dataset.dismiss || '')}">${svg('x', 20)}</button>`;
    let timer;
    const done = () => { clearTimeout(timer); el.remove(); };
    q('button', el).addEventListener('click', done);
    while (qa('.dp-toast', region).length >= 3) q('.dp-toast', region).remove();
    region.appendChild(el);
    timer = setTimeout(() => (el.contains(document.activeElement) ? el.addEventListener('focusout', done, { once: true }) : done()), 5000);
  }

  window.DP = { trapFocus, lockScroll, unlockScroll, toast, formatMoney, root: ROOT };

  /* the floating help hides while any overlay is open */
  let overlays = 0;
  document.addEventListener('dp:overlay:change', (e) => {
    overlays = Math.max(0, overlays + (e.detail && e.detail.open ? 1 : -1));
    const help = q('[data-dp-help]');
    if (help) help.hidden = overlays > 0;
  });

  define('toast-region', class extends HTMLElement {});

  define('dp-disclosure', class extends HTMLElement {
    connectedCallback() {
      const btn = q('.dp-disc__btn', this), from = this.dataset.staticFrom;
      if (!btn) return;
      btn.addEventListener('click', () => this.set(!this.hasAttribute('data-open')));
      if (from) {
        const mq = matchMedia(`(min-width: ${from}px)`);
        const apply = () => { btn.disabled = mq.matches; this.set(mq.matches); };
        apply(); mq.addEventListener('change', apply);
      }
    }
    set(open) {
      this.toggleAttribute('data-open', open);
      const btn = q('.dp-disc__btn', this);
      if (btn) btn.setAttribute('aria-expanded', open);
    }
  });

  /* wishlist */
  const syncWishlist = () => {
    const handles = store.get('dp:wishlist');
    qa('[data-dp-wishlist]').forEach((b) => {
      const on = handles.includes(b.dataset.dpWishlist), label = on ? b.dataset.labelRemove : b.dataset.labelAdd;
      b.setAttribute('aria-pressed', on);
      if (label) b.setAttribute('aria-label', label);
    });
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-dp-wishlist]');
    if (!b) return;
    e.preventDefault();
    const h = b.dataset.dpWishlist, cur = store.get('dp:wishlist');
    const list = cur.includes(h) ? cur.filter((x) => x !== h) : [h, ...cur].slice(0, 100);
    if (!store.set('dp:wishlist', list)) return;
    syncWishlist();
    emit('dp:wishlist:change', { handles: list });
  });
  let syncQueued = false;
  new MutationObserver(() => { if (!syncQueued) { syncQueued = true; requestAnimationFrame(() => { syncQueued = false; syncWishlist(); }); } }).observe(document.documentElement, { childList: true, subtree: true });
  syncWishlist();

  /* product carousel: home rails, related products and recently viewed */
  define('product-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = q('[data-rail-track]', this);
      this.prev = q('[data-rail-prev]', this);
      this.next = q('[data-rail-next]', this);
      this.thumb = q('[data-rail-thumb]', this);
      if (!this.track) return;
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.prev.addEventListener('click', () => this.scrollBySide(-1));
      this.next.addEventListener('click', () => this.scrollBySide(1));
      this.update();
    }
    scrollBySide(direction) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const dir = document.documentElement.dir === 'rtl' ? -direction : direction;
      this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: reduced ? 'auto' : 'smooth' });
    }
    update() {
      if (!this.track) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const pos = Math.abs(this.track.scrollLeft);
      const visible = this.track.scrollWidth ? Math.min(1, this.track.clientWidth / this.track.scrollWidth) : 1;
      const progress = max > 0 ? pos / max : 0;
      this.prev.disabled = pos <= 1;
      this.next.disabled = max <= 1 || pos >= max - 1;
      this.thumb.style.width = visible * 100 + '%';
      this.thumb.style.insetInlineStart = progress * (1 - visible) * 100 + '%';
    }
  });

  /* recently viewed */
  define('recently-viewed', class extends HTMLElement {
    connectedCallback() {
      const current = this.dataset.current, rail = q('[data-dp-recent-rail]', this), tpl = q('[data-dp-recent-skeleton]', this);
      let recent = store.get('dp:recent');
      if (current) { recent = [current, ...recent.filter((h) => h !== current)].slice(0, 12); store.set('dp:recent', recent); }
      const list = recent.filter((h) => h !== current).slice(0, 8);
      if (!list.length) return;
      this.hidden = false;
      const slots = list.map(() => { const s = document.createElement('li'); s.className = 'dp-hrail__item'; s.appendChild(tpl.content.cloneNode(true)); rail.appendChild(s); return s; });
      Promise.all(list.map((handle, i) => fetch(`${ROOT}products/${encodeURIComponent(handle)}?section_id=product-card-render`)
        .then((r) => {
          if (r.ok) return r.text();
          if (r.status === 404) store.set('dp:recent', store.get('dp:recent').filter((h) => h !== handle));
          return '';
        })
        .then((html) => {
          const card = html && q('article', new DOMParser().parseFromString(html, 'text/html'));
          if (card) slots[i].replaceChildren(document.importNode(card, true)); else slots[i].remove();
          return !!card;
        })
        .catch(() => { slots[i].remove(); return false; })
      )).then((ok) => { if (ok.some(Boolean)) { syncWishlist(); q('product-rail', this)?.update(); } else (this.closest('.shopify-section') || this).remove(); });
    }
  });

  /* localization selects, newsletter validation, tooltips */
  document.addEventListener('change', (e) => {
    const f = e.target.matches('[data-dp-localization] select') && e.target.form;
    if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-dp-newsletter]');
    if (!form) return;
    const input = q('input[type=email]', form);
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) return;
    e.preventDefault();
    input.setAttribute('aria-invalid', 'true'); input.focus();
    q('.dp-newsletter__msg-wrap', form).replaceChildren(q('[data-dp-newsletter-error]', form.parentNode).content.cloneNode(true));
  });
  document.addEventListener('input', (e) => { if (e.target.matches('[data-dp-newsletter] input[type=email]')) e.target.removeAttribute('aria-invalid'); });
  const tip = (e, on) => {
    const t = e.target.closest && e.target.closest('[data-dp-tooltip]'), el = t && document.getElementById(t.getAttribute('aria-describedby'));
    if (el) el.hidden = !on;
  };
  ['mouseover', 'focusin'].forEach((n) => document.addEventListener(n, (e) => tip(e, true)));
  ['mouseout', 'focusout'].forEach((n) => document.addEventListener(n, (e) => tip(e, false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') qa('.dp-tooltip:not([hidden])').forEach((t) => { t.hidden = true; }); });
})();
